import { observer } from "mobx-react-lite";
import React, { useContext } from "react";

import { ApiContext,UserContext } from "../contexts";
import MoreDetailsBtn from "./MoreDetailsBtn";

const YourNewHomeFooter = observer(
  (props: { isShareOrMyDomaineMode: boolean; isHouseLand: boolean }) => {
    const apiContext = useContext(ApiContext);
    const userContext = useContext(UserContext);
    const showFurtherCustomise =
      !props.isHouseLand &&
      apiContext.finalDetailsSettings.further_customise_enabled;

    const onClickMoreDetails = () => {
      window.open(apiContext.finalDetailsSettings.promo_link, "_blank");
    };

    return (
      <div className={"pyht-your-new-home-footer"}>
        {!props.isShareOrMyDomaineMode && (
          <>
            {showFurtherCustomise && (
              <>
                <div
                  className={"container section section-further-customise copy"}
                  dangerouslySetInnerHTML={{
                    __html:
                    apiContext.finalDetailsSettings.further_customise_copy,
                  }}
                />
                <div className="pagebreak"></div>
              </>
            )}

            {apiContext.finalDetailsSettings.promo_enabled && (
              <>
                <div className={"container section section-final-promo"}>
                  {apiContext.finalDetailsSettings.promo_desktop_image && (
                    <img
                      className={"desktop"}
                      src={apiContext.finalDetailsSettings.promo_desktop_image}
                      alt={""}
                    />
                  )}
                  {apiContext.finalDetailsSettings.promo_mobile_image && (
                    <img
                      className={"mobile"}
                      src={apiContext.finalDetailsSettings.promo_mobile_image}
                      alt={""}
                    />
                  )}

                  {apiContext.finalDetailsSettings.promo_link !== "" && (
                    <MoreDetailsBtn
                      onClick={onClickMoreDetails}
                      title={
                        apiContext.finalDetailsSettings.promo_link_text !== ""
                          ? apiContext.finalDetailsSettings.promo_link_text
                          : "More Details"
                      }
                    />
                  )}
                </div>
                <div className="pagebreak"></div>
              </>
            )}

            {apiContext.finalDetailsSettings.thank_you_enabled && !userContext.isKioskMode && (
              <div
                className={"container section-thank-you copy"}
                dangerouslySetInnerHTML={{
                  __html: apiContext.finalDetailsSettings.thank_you_copy,
                }}
              />
            )}

            {userContext.isKioskMode && (
              <div
                className={"container section-thank-you copy"}
                dangerouslySetInnerHTML={{
                  __html: apiContext.finalDetailsSettings.kiosk_footer_copy,
                }}
              />
            )}
          </>
        )}

        <div
          className={"container section-disclaimer copy"}
          dangerouslySetInnerHTML={{
            __html: apiContext.finalDetailsSettings.disclaimer_copy,
          }}
        />
      </div>
    );
  }
);

export default YourNewHomeFooter;
